import { useSelector } from "react-redux";
import { InfoBanner } from "../../../components/InfoBanner";
import { ExternalLinkWrapper } from "../../../components/ExternalLinkWrapper";
import * as authSelectors from "../../auth/authSelectors";
import {
  heapsGoAdminProductUrl,
  heapsGoAdminVatRulesUrl,
} from "../heapsgo-admin-links";
import { Product } from "../models/product";

// On a rule the API's vat is the rule's rate for take-away, not for serving.
export const VAT_RULE_RATE_LABEL = "VAT percentage for take-away";

const A_VAT_RULE =
  'a VAT rule, such as "Food" or "Alcohol", which picks the right rate for take-away and for serving';

type Props = {
  product?: Pick<Product, "id" | "vatRuleId">;
};

export const ProductVatNotice = ({ product }: Props) => {
  const organizationKeyName =
    useSelector(authSelectors.selectedOrganizationKeyName) || "";

  return (
    <InfoBanner>
      {product?.vatRuleId ? (
        <>
          This product follows {A_VAT_RULE}, so its VAT percentage cannot be
          changed here.{"\n"}
          To change it, move the product to another VAT rule in the new admin.{" "}
        </>
      ) : (
        <>
          Products will stop carrying their own VAT percentage, and this field
          will be removed from the old admin soon.{"\n"}
          Each product will instead follow {A_VAT_RULE}. VAT rules are managed
          in the new admin.{" "}
        </>
      )}
      {/* Our own admin: keep the referrer, so the new admin can tell visits
          that came from here. */}
      {product?.vatRuleId ? (
        <ExternalLinkWrapper
          href={heapsGoAdminProductUrl(organizationKeyName, product.id)}
          rel="noopener"
        >
          Open this product in the new admin →
        </ExternalLinkWrapper>
      ) : (
        <ExternalLinkWrapper
          href={heapsGoAdminVatRulesUrl(organizationKeyName)}
          rel="noopener"
        >
          See your VAT rules in the new admin →
        </ExternalLinkWrapper>
      )}
    </InfoBanner>
  );
};
